// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"226":"react-markdown","420":"jsonschema"}[chunkId] + "." + {"226":"aceb1ec7","420":"2b966800"}[chunkId] + ".js";
};